import { Component, OnInit } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MenuItem } from 'src/app/app.models';
import { Settings, AppSettings } from 'src/app/app.settings';
import { AppService } from 'src/app/app.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SitesService } from 'src/app/admin/1.tv/sites/sites.service';
import { StripeResponseService } from 'src/app/services/stripe-response.service';

@Component({
  selector: 'app-cart-overview',
  templateUrl: './cart-overview.component.html',
  styleUrls: ['./cart-overview.component.scss']
})
export class CartOverviewComponent implements OnInit {
  public menuItems: MenuItem[] = [];
  public settings: Settings;
  currency: string;
  symbol: string;
  euro: string;
  public companyId: string;
  public siteId: string;

  constructor(public appService: AppService,
              public appSettings: AppSettings,
              private bottomSheetRef: MatBottomSheetRef<CartOverviewComponent>,
              public snackBar: MatSnackBar,
              private stripeResponseService: StripeResponseService,
              private sitesService: SitesService, ) {
    this.settings = this.appSettings.settings;
    this.companyId = stripeResponseService.companyId;
    this.siteId = stripeResponseService.siteId;
  }

  ngOnInit() {

    this.sitesService.findSiteByCompanyIdSiteId(this.companyId, this.siteId)
    .subscribe((sites) => {

      this.currency = (sites[0].cashCurrency !== undefined) ? sites[0].cashCurrency : 'GBP';
      if (this.currency === 'EUR'){
        this.symbol = '';
        this.euro = '€';
      } else {
        this.symbol = 'symbol';
        this.euro = '';
      }
    });
    this.menuItems = this.appService.Data.cartList;
  }

  public hideSheet(isRedirect: boolean){
    this.bottomSheetRef.dismiss(isRedirect);
  }

  public clearCart(){
    this.appService.Data.cartList.length = 0;
    this.appService.Data.totalPrice = 0;
    this.hideSheet(false);
  }

  public remove(item: MenuItem, event: any) {
    const index: number = this.appService.Data.cartList.indexOf(item);
    if (index !== -1) {
      item.cartCount = 0;
      this.appService.Data.cartList.splice(index, 1);
      this.appService.calculateCartTotal();
    }
    if (this.appService.Data.cartList.length == 0){
      this.hideSheet(false);
    }
    event.preventDefault();
  }

  public counterChange(menuItem: MenuItem, count: number){
    menuItem.cartCount = count;
    this.appService.calculateCartTotal();
    // if (menuItem.cartCount <= menuItem.availibilityCount){
    //   this.appService.calculateCartTotal();
    // }
    // else{
    //   menuItem.cartCount = menuItem.availibilityCount;
    //   this.snackBar.open('You can not add more items than available. In stock ' + menuItem.availibilityCount + ' items and you already added ' + menuItem.cartCount + ' item to your cart', '×', { panelClass: 'error', verticalPosition: 'top', duration: 5000 });
    // }
  }


}
